/** Adds a "Gi" suffix to the size */
export function asGibiBytes(size: number): string {
    return `${size}Gi`;
}
